// Constants
export const VIEW_MODES = {
  CARD: 'card',
  TABLE: 'table'
};

export const BUTTON_CLASSES = {
  PRIMARY: "inline-flex items-center gap-x-1.5 rounded-md bg-primary px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-primaryDark focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary",
  SECONDARY: "inline-flex items-center gap-x-1.5 rounded-md bg-gray-100 dark:bg-gray-800 px-3 py-2 text-sm font-semibold text-primary border border-primary",
  CREATE: "inline-flex items-center px-4 py-2 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-primary hover:bg-primaryDark focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary"
};

export const ICON_CLASSES = {
  SMALL: "h-4 w-4",
  MEDIUM: "h-5 w-5",
  LARGE: "h-12 w-12"
};

export const TABLE_HEADER_CLASSES = "px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider";
export const TABLE_CELL_CLASSES = "px-6 py-4 whitespace-nowrap";
